import { useState, useContext, useEffect } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm } from "react-hook-form"
import API from '../API'
import { AdminAddOrderToPersonFunction, AdminReloadFunction } from '../interfaces';
import { AdminQueryOrder, AdminProjectsAndOrdersResponse } from '../../../backend/src/api/dto';

type FormValues = {
    startDate: string
    endDate: string
    orderId: number | string
}

function AdminAddOrderToUser({ item, reload, alreadyAdded, addFunction }: {
    item: any,
    reload: AdminReloadFunction,
    alreadyAdded: AdminQueryOrder[],
    addFunction: AdminAddOrderToPersonFunction,
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: {
            startDate: '',
            endDate: '',
            orderId: '',
        }
    })

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [data, setData] = useState<AdminProjectsAndOrdersResponse>();
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)


    useEffect(() => {
        API.getProjectsAndOrders({ divisionMatch: 'true' }).then(data => {
            setData(data)
        })
    }, [])

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        //const form = getValues();
        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data2) => {
                setLoading(false);
                setApiResult({
                    status: true,
                })
                addFunction(data2.orderId, data2.startDate, data2.endDate).then(() => {
                    if (reload) {
                        console.log('in reload')
                        reload().then(() => {
                            closeModal(null);
                            resolve(1)
                        })
                    } else {
                        closeModal(null);
                        resolve(1)
                    }
                }).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })
                setSending(false)
            })()
        })
    }

    return (
        <Modal
            buttons={modalButtons}
            title={'Pridať osobu ku komponentu'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <form style={{ minHeight: '300px' }}>
                <div className="row mb-2">
                    <div className="col-4 text-end mt-2">
                        Komponent
                    </div>
                    <div className="col-8">
                        <select className="form-select" {...register("orderId")} >
                            {
                                data?.projects.filter(project => {
                                    return project.flag === 0 && data?.orders.find(item => item.projectId === project.projectId)
                                }).map(project => {
                                    return (
                                        <optgroup label={project.nameId + ' (' + project.name + ')'}>
                                            {
                                                data?.orders.filter(item => {
                                                    return item.projectId === project.projectId
                                                }).map(order => {
                                                    return (
                                                        <option value={order.orderId}>{order.name}</option>
                                                    )
                                                })

                                            }
                                        </optgroup>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 mt-1 text-end">
                        <label className="form-label">Od</label>
                    </div>
                    <div className="col-auto">
                        <input type="month" {...register("startDate")} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 mt-1 text-end">
                        <label className="form-label">Do</label>
                    </div>
                    <div className="col-auto">
                        <input type="month" {...register("endDate")} />
                    </div>
                </div>
            </form>
        </Modal>
    )

}

export default AdminAddOrderToUser
